// Backend error code returned when an ad account has zero last-30-day spend (see core/lib/errors).
export const ZERO_SPEND_AD_ACCOUNT_ERROR_CODE = 'ZERO_SPEND_AD_ACCOUNT'

export const isZeroSpendError = (error: any): boolean =>
	error?.response?.data?.code === ZERO_SPEND_AD_ACCOUNT_ERROR_CODE

export const parseError = (error: any): string => {
	if (error?.response?.data?.message) {
		return error.response.data.message
	}
	return 'Unexpected error has occurred, please try again'
}
